export enum RseType {
  waterSaving = 'WATER_SAVING',
  insertion = 'INSERTION'
}
